import React from 'react';
import { useReveal } from '../lib/useReveal';
export function StatsBar() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#2D1B1B] py-6 border-y border-[#C9A96E]/10 relative z-20" data-id="element-292">
      <div className="container mx-auto px-5" data-id="element-293">
        <div ref={ref1} className={`reveal flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-294">
          <div className="flex items-center gap-2" data-id="element-295">
            <span className="text-[#C9A96E] font-bold text-xl" data-id="element-296">+500</span>
            <span className="text-[#FAF3E8] text-sm uppercase tracking-wider font-medium" data-id="element-297">
              mujeres ya lo tienen
            </span>
          </div>
          <div className="hidden md:block w-px h-8 bg-[#C9A96E]/20" data-id="element-298"></div>
          <div className="flex items-center gap-2" data-id="element-299">
            <span className="text-[#C9A96E] font-bold text-xl" data-id="element-300">6</span>
            <span className="text-[#FAF3E8] text-sm uppercase tracking-wider font-medium" data-id="element-301">
              Tomos completos
            </span>
          </div>
          <div className="hidden md:block w-px h-8 bg-[#C9A96E]/20" data-id="element-302"></div>
          <div className="flex items-center gap-2" data-id="element-303">
            <span className="text-[#C9A96E] font-bold text-xl" data-id="element-304">6</span>
            <span className="text-[#FAF3E8] text-sm uppercase tracking-wider font-medium" data-id="element-305">
              Bonos incluidos
            </span>
          </div>
          <div className="hidden md:block w-px h-8 bg-[#C9A96E]/20" data-id="element-306"></div>
          <div className="flex items-center gap-2" data-id="element-307">
            <span className="text-[#C9A96E] font-bold text-xl" data-id="element-308">4.9/5</span>
            <span className="text-[#FAF3E8] text-sm uppercase tracking-wider font-medium" data-id="element-309">
              calificación ⭐
            </span>
          </div>
        </div>
      </div>
    </section>;
}